import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { PortalToggleMenu } from "./Common";
import Cs from "../../../services/CommonService";
import { DraftBadge } from "../../Common/NotificationPill";
import { UserName } from '../../UserProfile/UserInfoPopup';
import { useSubscriptionAccess } from '../../Subscriptions/useSubscription';
import { FormFieldCard } from "../../Common/FormFieldsView";
import { usePageLocale } from "../../../hooks/useLocale";
import FormTemplateService from "../../../services/FormTemplateService";
import { useCurrentUserHook } from "../../Authentication/useUserHook";
import { LinkFontAwesomeIcon, DsRefLink } from "../../Common/ImageIcons";
import moment from '../../../../node_modules/moment/min/moment.min.js';
import {FontAwesomeLink} from "../../Common/Button";

const JourneyBlock = (props) => {
  let components = {
    //'ckd_journey':CancerJourneyBlock,
    //'cancer_journey':CancerJourneyBlock,
    //'infant_journey':MotherInfantJourneyBlock,
  }

  const TagName = components[props.journeyType];  

  if(TagName){
    return <TagName {...props}/>
  }

  return <DefaultBlock {...props}/>   
}

const DefaultBlock = (props) => {
  const [loading, setLoading] = useState(true);
  const [formFields, setFormFields] = useState([]);
  let {journey, menuOptions, dataSource} = props;
  let {data, data_source} = journey;
  
  useEffect(()=>{
    getFormFields();
  }, [])

  let getFormFields = () => { 
    FormTemplateService.getFormFields({
      'ids':[dataSource.child_form], 
    }).then((res)=>{
      if(res.status === 200){
        setFormFields(res.data.form_fields[dataSource.child_form]);
        setLoading(false);
      }
    })
  }

  return (
    <div className="p10">
      <div className="flex justspacebetween aligncenter font-14">
        <span className="flex bold"> 
          <span>Last Updated</span>
          <span className="m-l-20">{Cs.formatUpdateDate(journey?.updated_at)}</span>
        </span>
        
        <Link data-tip="Edit"
          className="icon-black-cirle table-icon brd-30 flex aligncenter justifycenter tooltip" 
          to={`/ecn/form/${journey.form_id}/${journey.id}`}>
            <i className="fas fa-edit" />
        </Link>
      </div>

      <div className="mxh-250 m-t-5 scroll-auto">
        <div className="table card-table p-5">
          <FormFieldCard formFields={formFields} 
            data={data} dataSource={data_source}/>
        </div>  
      </div> 
    </div>
  ) 
}

export default JourneyBlock;